import OrderTableView from "../../Components/Forms/OrderTableView";

const OrderTable = () => {
    return (
        <div>
            <OrderTableView />
        </div>
    );
};

export default OrderTable;
